(function () {
 console.log("DOMContentLoaded scscscs");
  document.addEventListener("DOMContentLoaded", function () {
   console.log("DOMContentLoaded");
    const wrapper = document.getElementById("notification-widget");
    if (!wrapper) return;
 
    // Define and apply styles for the popup and button
    const styles = `
         .notification-btn {
             background-color: #fff;
             border: 1px solid black;
             color: black;
             padding: 12px 24px;
             text-align: center;
             width: 100%;
             cursor: pointer;
             text-transform: uppercase;
         }
         #popup-body.overlay {
             position: fixed;
             z-index: 9998;
             top: 0;
             bottom: 0;
             left: 0;
             right: 0;
             background: rgba(0, 0, 0, 0.7);
             transition: opacity 200ms;
             visibility: hidden;
             opacity: 0;
         }
         #popup-wrapper {
             margin: 0;
              z-index: 9999;
              padding: 15px;
              background: #fff;
              border-radius: 5px;
              max-width: 460px;
              position: relative;
              transform: translate(-50%, -50%);
              top: 50%;
              left: 50%;
         }
         #popup-close {
             position: absolute;
             top: 5px;
             right: 15px;
             transition: all 200ms;
             font-size: 20px;
             font-weight: bold;
             text-decoration: none;
             color: #333;
             cursor: pointer;
         }
         #popup-close:hover {
             color: #d80606;
         }
         #popup-title {
             margin: 0;
             font-size: 20px;
             max-width: 350px;
             text-transform: uppercase;
         }
         #popup-text {
             margin: 10px 0;
             font-size: 14px;
         }
         #popup-form {
             display: flex;
             flex-direction: column;
             gap: 10px;
         }
         #popup-form input {
             padding: 10px;
             border: 1px solid #caced1;
             border-radius: 0.25rem;
             max-width: 100%;
         }
         #popup-form input::placeholder {
             font-size: 1rem;
         }
         #popup-form button {
             padding: 15px 15px 10px;
             border: none;
             text-transform: uppercase;
             background: #fed1bd;
             color: #2d2e2f;
             cursor: pointer;
             font-weight: 500;
         }
         .custom-select {
             position: relative;
         }
         .custom-select select {
             appearance: none;
             width: 100%;
             padding: 5px 10px;
             background-color: #fff;
             border: 1px solid #caced1;
             border-radius: 0.25rem;
             color: #000;
             cursor: pointer;
             font-size: 12px;
         }
         .custom-select::before,
         .custom-select::after {
             --size: 0.3rem;
             content: "";
             position: absolute;
             right: 1rem;
             pointer-events: none;
         }
         .custom-select::before {
             border-left: var(--size) solid transparent;
             border-right: var(--size) solid transparent;
             border-bottom: var(--size) solid black;
             top: 40%;
         }
         .custom-select::after {
             border-left: var(--size) solid transparent;
             border-right: var(--size) solid transparent;
             border-top: var(--size) solid black;
             top: 55%;
         }
         
         #popup-message {
             margin: 10px 0;
             font-size: 14px;
             color: #aca475;
             font-weight: 700;
         }   

         #checkbox-wrapper label {
           margin-left: 10px;
         }
     `;
 
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
 
    // Create and append the overlay for the popup
    const overlay = document.createElement("div");
    overlay.innerHTML = `
         <div id="popup-body" class="overlay">
             <div id="popup-wrapper">
                 <h3 id="popup-title"></h3>
                 <span id="popup-close">&times;</span>
                 <div id="popup-text"></div>
                  <div id="popup-message"></div> <!-- Added message div -->
                 <form id="popup-form">
                     <div class="custom-select">
                         <select name="select-size" required>
                         </select>
                     </div>
                     <input name="email" placeholder="Email" type="email" required />
                 </form>
             </div>
         </div>
     `;
 
    wrapper.appendChild(overlay);
 
    const popupBody = document.getElementById("popup-body");
    const popupClose = document.getElementById("popup-close");
    const popupOpenButton = document.getElementById("popup-open");
    const popupTitle = document.getElementById("popup-title");
    const popupText = document.getElementById("popup-text");
    const sizeSelect = document.querySelector("select[name='select-size']");
    const form = overlay.querySelector("#popup-form");
    const popupMessage = document.getElementById("popup-message");
 
    if (!popupBody || !popupClose || !popupOpenButton || !popupTitle || !sizeSelect) return;
 
    // Parse fields and type to be included in the form from data attribute
    const fields = JSON.parse(popupOpenButton.getAttribute("data-fields") || '["email"]');
    const type = popupOpenButton.getAttribute("data-type") || "notify-me";
    const typeConfig = {
       "notify-me": {
          text: "Register to receive a notification as soon as this item is back in stock",
          buttonText: "Notify me",
       },
       "coming-soon": {
          text: "Register your interest to hear more about this item",
          buttonText: "Register Interest",
       },
    };
 
     // Get the script tag containing product data (JSON-LD)
     const scriptTag = document.getElementById('productData');
 
     // Initialize an empty productData object
     let productData = null;
 
     // Check if the script tag exists
     if (scriptTag) {
         // Log the raw content of the script tag
         //console.log('Raw product data content:', scriptTag.textContent);
 
         try {
             // Attempt to parse the content
             productData = JSON.parse(scriptTag.textContent || '{}');
 
             // Check if productData is an object and has the 'hasVariant' array
             if (productData && Array.isArray(productData.hasVariant)) {
                 console.log('Valid product data:', productData);
             } else {
                 console.log('No variant data', productData);
             }
         } catch (error) {
             // Log the error when parsing fails
             console.error('Error parsing product data:', error);
         }
     } else {
         // Handle case where the script tag is not found
         console.error('Product data script tag not found.');
     }
 
     // Fallback: Get product data from Shopify global variable
     if (!productData && typeof Shopify !== 'undefined' && Shopify.product) {
     productData = Shopify.product;
     console.log('Product Data from Shopify global:', productData);
     }
 
     /* If productData is still null or missing variants, show an alert
     if (!productData || !productData.hasVariant) {
     alert("Product data or variants not found");
     return;
     }*/
 
     // Function to show popup
     function showPopup() {
         if (!productData) {
             alert("Product data not found");
             return;
         }
 
         popupTitle.innerHTML = productData.name || 'Product';
 
         // Remove only the dynamically added form fields (inputs and button)
         const dynamicFields = form.querySelectorAll('input:not([name="email"]), button, #checkbox-wrapper');
         dynamicFields.forEach((field) => field.remove());  // Remove each dynamic field
 
         // If there are no variants, display a default "No size" option
       
         if (!productData.hasVariant || productData.hasVariant.length === 0) {
             // Hide the size select input since no variants are available
             sizeSelect.style.display = 'none';
             sizeSelect.removeAttribute('required');
         } else {
             sizeSelect.style.display = 'block';
             sizeSelect.setAttribute('required', '');
             sizeSelect.innerHTML = ''; // Clear existing options if any
 
             productData.hasVariant.forEach((variant) => {
                 const option = document.createElement("option");
                 option.value = variant.name;
                 option.textContent = variant.name;
                 sizeSelect.appendChild(option);
             });
         }
 
         popupText.innerText = typeConfig[type].text; // Set popup text from typeConfig
 
         // Define form fields dynamically based on the fields array
         const fieldMap = {
             email: `<input name="email" placeholder="Email" type="email" required />`,
             mobile: `<input name="mobile" placeholder="Mobile" type="tel"/>`,
             firstName: `<input name="firstName" placeholder="First name" type="text"/>`,
             lastName: `<input name="lastName" placeholder="Last name" type="text"/>`,
         };
 
         // Add form fields based on fields array
         fields.forEach((field) => {
             if (fieldMap[field]) {
                 form.insertAdjacentHTML("beforeend", fieldMap[field]);
             }
         });
 
         form.insertAdjacentHTML("beforeend", `<div id="checkbox-wrapper"></div>`);
         const checkboxWrapper = document.getElementById("checkbox-wrapper");
         checkboxWrapper.insertAdjacentHTML("beforeend", `<input type="checkbox" name="mailList" id="mailList" />`);
         checkboxWrapper.insertAdjacentHTML("beforeend", `<label for="mailList">Subscribe to our mailing list</label>`);
         form.insertAdjacentHTML("beforeend", `<button type="submit">${typeConfig[type].buttonText}</button>`);
 
         // Show popup
         popupBody.style.visibility = "visible";
         popupBody.style.opacity = 1;
     } 
 
     // Function to hide the popup
     function hidePopup() {
         popupBody.style.visibility = "hidden";
         popupBody.style.opacity = 0;
         popupMessage.innerText = "";
     }
 
     // Event listeners for opening and closing the popup
     popupOpenButton.addEventListener("click", showPopup);
     popupClose.addEventListener("click", hidePopup);
 
     // Form submission handler
     if (form) {
     form.addEventListener("submit", async function (event) {
         event.preventDefault();
         popupMessage.innerText = ""; // Clear previous messages
 
         let formData = {
             email: form.querySelector("input[name='email']").value,
             subscribe: form.querySelector("input[name='mailList']").checked,
         };
 
         // Add optional form fields
         if (fields.includes("firstName")) {
             formData.firstName = form.querySelector("input[name='firstName']").value;
         }
         if (fields.includes("lastName")) {
             formData.lastName = form.querySelector("input[name='lastName']").value;
         }
         if (fields.includes("mobile")) {
             formData.mobile = form.querySelector("input[name='mobile']").value;
         }
 
         // Add variant ID if applicable
         if (productData.hasVariant && productData.hasVariant.length > 0) {
             const selectedSize = sizeSelect.value;
             const selectedVariant = productData.hasVariant.find(
                 (variant) => variant.name === selectedSize
             );
             if (selectedVariant) {
                 const variantId = selectedVariant['@id'].split('variant=')[1].split('#')[0];
                 formData.variantRef = variantId;
             }
         } else if (productData.offers) {
             const offer = productData.offers;
             const variantId = offer['@id'].split('variant=')[1].split('#')[0];
             formData.variantRef = variantId;
         }
 
         formData[type === "coming-soon" ? "comingSoon" : "notifyMe"] = true;
 
         console.log("Form Data:", JSON.stringify(formData, null, 2));
 
         const TENANT_ID = "kipandco";
         const TOKEN_URL = `https://2hrfu2sis6cfjbslmkh6aslv7e0zpesc.lambda-url.ap-southeast-2.on.aws?tenant_id=${TENANT_ID}`;
 
         console.log('Token URL:', TOKEN_URL);
        async function getAccessToken() {
           try {
             const response = await fetch(TOKEN_URL, {
               method: "GET"
             });
         
             if (!response.ok) {
               throw new Error(`HTTP error! Status: ${response.status}`);
             }
         
             const data = await response.json();
             console.log("Access token response:", data);
             return data.access_token || null;
           } catch (error) {
             console.error("Error fetching access token:", error);
             return null;
           }
         }
 
         const ACCESS_TOKEN = await getAccessToken();
 
         if (!ACCESS_TOKEN) {
             popupMessage.innerText = "Failed to fetch access token.";
             return;
         }
 
         try {
             const response = await fetch("https://api.au-aws.thewishlist.io/services/wsservice/api/wishlist/items/customerInterest", {
                 method: "POST",
                 headers: {
                     "Content-Type": "application/json",
                     "Accept": "application/json",
                     "Authorization": `Bearer ${ACCESS_TOKEN}`,
                     "X-Twc-Tenant": TENANT_ID
                 },
                 body: JSON.stringify(formData)
             });
 
             if (!response.ok) {
                 const errorText = await response.text();
                 throw new Error(`Server Error: ${errorText}`);
             }
 
             const data = await response.json();
             console.log("API Response Data:", data);
             popupMessage.innerText = "Form submitted successfully";
             setTimeout(hidePopup, 3000);
 
         } catch (error) {
             console.error("Error submitting form:", error);
             if (error.message.includes("is already exists")) {
                 popupMessage.innerText = "You have already subscribed for this product.";
             } else {
                 popupMessage.innerText = "Form submission failed: " + error.message;
             }
             setTimeout(hidePopup, 3000);
         }
     });
   }
 
  
     // Function to create and append the "Notify Me" button
     function createNotifyMeButton() {
         console.log("createNotifyMeButton");
         // Check if the "Notify Me" button already exists to avoid duplicates
         if (document.getElementById("popup-open-button")) return;
 
         // Find the original product button
         const productButton = document.querySelector(".product-form__buy-buttons button[type='submit']");
         if (!productButton) return;
 
         // Create the "Notify Me" button
         const notifyMeButton = document.createElement("button");
         notifyMeButton.id = "popup-open-button";
         notifyMeButton.setAttribute("data-fields", '["mobile", "firstName", "lastName"]');
         notifyMeButton.setAttribute("data-type", "notify-me");
         notifyMeButton.className = "product-form__submit button button--full-width button--secondary";
         notifyMeButton.innerText = "Notify Me";
 
         // Hide the button initially
         notifyMeButton.style.display = "none";
 
         // Add event listener to the "Notify Me" button
         notifyMeButton.addEventListener("click", () => {
             console.log("Notify Me button clicked!");
             showPopup(); // Assuming showPopup is defined elsewhere
         });
 
         // Append the "Notify Me" button next to the original button
         productButton.parentElement.appendChild(notifyMeButton);
     }
 
     // Function to toggle button visibility based on stock status
     function toggleButtonVisibility() {
         const productButton = document.querySelector(".product-form__buy-buttons > button");
         const notifyMeButton = document.getElementById("popup-open-button");
 
         if (!productButton || !notifyMeButton) return;
 
         // Check if the product button is disabled (out of stock)
         if (productButton.hasAttribute("disabled")) {
             console.log("Out of stock variant detected. Showing Notify Me button.");
             productButton.style.display = "none";
             notifyMeButton.style.display = "block";
         } else {
             console.log("In stock variant detected. Showing original button.");
             productButton.style.display = "block";
             notifyMeButton.style.display = "none";
         }
     }
 
     // Function to detect URL changes (when ?variant= changes)
     function onUrlChange(callback) {
         let currentUrl = location.href;
         setInterval(() => {
             if (location.href !== currentUrl) {
                 currentUrl = location.href;
                 callback(); // Call the provided function when the URL changes
             }
         }, 200); // Check for URL changes every 200ms
     }
 
     // Create the "Notify Me" button on page load
     createNotifyMeButton();
 
     // Listen for URL changes and toggle button visibility accordingly
     onUrlChange(toggleButtonVisibility);
 
     // Initial call to toggle button visibility on page load
     toggleButtonVisibility();
 
 });
})();    

